import { api } from 'api';
import { call, put, SagaReturnType } from 'redux-saga/effects';
import * as R from 'remeda';
import { actionActions } from 'store/data/action';
import { JwtFeature } from 'utility/jwt';

import { operationWrapper } from './operationWrapper';

// Persists an edited Data.Action via Action_Update and updates the action
// domain entry. Returns the updated Data.Action so callers can act on the
// fresh server-side state.
// Requires action.improvementAreaId to be non-null — returns undefined early
// if tenantId, feature access, or improvementAreaId are missing.
export function* updateAction(args: { action: Data.Action }) {
  const { action } = args;

  function* work(tenantId: string) {
    if (!R.isDefined(action.improvementAreaId)) return;

    const { action: updatedAction }: SagaReturnType<typeof api.updateAction> =
      yield call(api.updateAction, { tenantId, action });

    yield put(actionActions.update(updatedAction));
    return updatedAction;
  }

  return (yield call(operationWrapper, work, JwtFeature.Improvements)) as
    | Data.Action
    | undefined;
}
